import { resolveLocalized, type TemplateField } from "@arna-med/shared";
import type { TFunction } from "i18next";

// KZ-SOAP general-record field keys → i18n label keys.
// Mirrors KZ_SOAP_SECTIONS used to render the general record in the report views.
export const KZ_SOAP_LABEL_KEYS: Record<string, string> = {
  complaints: "report.kzsoap.complaints",
  anamnesisDisease: "report.kzsoap.anamnesisDisease",
  anamnesisLife: "report.kzsoap.anamnesisLife",
  objectiveStatus: "report.kzsoap.objectiveStatus",
  localStatus: "report.kzsoap.localStatus",
  diagnosis: "report.kzsoap.diagnosis",
  plan: "report.kzsoap.plan",
};

/**
 * Resolve a field key (as used in AI findings) to a human-readable, localized
 * label: a localized template-field label first, then a KZ-SOAP section label,
 * finally the raw key as a fallback.
 */
export function resolveFieldLabel(
  key: string,
  fields: TemplateField[] | undefined,
  locale: string,
  t: TFunction,
): string {
  const field = fields?.find((f) => f.key === key);
  if (field) return resolveLocalized(field.label, locale);
  const i18nKey = KZ_SOAP_LABEL_KEYS[key];
  if (i18nKey) return t(i18nKey);
  return key;
}
